export const initialFormValues = {
  password: '',
  confirmPassword: '',
} as const
